export function checkText(text) {
  const validRegex = /[aA-zZ]{3,}/;
  return text.match(validRegex) ? false : true;
}
